import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconDownloading$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconDownloading extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '7d251b4bc2e997ac3586294affcfb01c43dc76e2', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '82be8ecacd978fb5bff5c5daf2a7defa393bad21', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '860c5ee537b851213bb59e991c3fab2ba5947b16', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.857 6a.5.5 0 0 0-.5-.5H8.5A.5.5 0 0 0 8 6v7a.5.5 0 0 0 .5.5h1.857a.5.5 0 0 0 .5-.5zM16 6a.5.5 0 0 0-.5-.5h-1.857a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5H15.5a.5.5 0 0 0 .5-.5z", fill: "currentColor" }), h("mask", { key: '3993a02860aae509edac2180c42811bf849c3258', id: "a", maskUnits: "userSpaceOnUse", x: "0", y: "9", width: "12", height: "12" }, h("path", { key: '51fd927761682d676c1fc488a82c029b7fa3b413', fill: "#fff", d: "M.75 9.75H12v11H.75z" })), h("g", { key: '53407525f372467a679f9d3b64b4ac1ac505cdae', mask: "url(#a)" }, h("path", { key: '654a04e87177ea994b5445ee27dd2706b4be2a01', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12 .5a9 9 0 1 0 0 18 9 9 0 0 0 0-18M12 2c4.136 0 7.5 3.367 7.5 7.5S16.136 17 12 17c-4.135 0-7.5-3.367-7.5-7.5C4.5 5.368 7.864 2 12 2", fill: "#DB0A40" })))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-downloading", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-downloading"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-downloading":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconDownloading$1);
            }
            break;
    } });
}

const CosmosIconDownloading = CosmosIconDownloading$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconDownloading, defineCustomElement };
